module.exports = __webpack_public_path__ + "img/2.4f99e7e8.jpg";